var React = require('react');

function Search16 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11.5 7a4.499 4.499 0 11-8.998 0A4.499 4.499 0 0111.5 7zm-.82 4.74a6 6 0 111.06-1.06l3.04 3.04a.75.75 0 11-1.06 1.06l-3.04-3.04z"}));
}

Search16.defaultProps = {"width":"25","height":"25","viewBox":"0 0 16 16"};

module.exports = Search16;

Search16.default = Search16;
